/** Keys typed here are text: a field, an editable region, or a select, whose
 *  typeahead takes letters too. */
export function isTextEntry(target: EventTarget | null): boolean {
  const el = target as HTMLElement | null;
  return (
    el?.tagName === "INPUT" ||
    el?.tagName === "TEXTAREA" ||
    el?.tagName === "SELECT" ||
    !!el?.closest?.('[contenteditable]:not([contenteditable="false"])')
  );
}
